import request from '@/utils/request'

// APP用户总览分页列表
export function appUserList(data) {
  return request({
    url: '/system/api/admin/appUser/list',
    method: 'get',
    params: data
  })
}

// 修改用户状态
export function appUserUpdateStatus(data) {
  return request({
    url: '/system/api/admin/appUser/updateStatus',
    method: 'get',
    params: data
  })
}

// 重置密码
export function updateAppPwd(data) {
  return request({
    url: '/system/api/admin/appUser/updateAppPwd',
    method: 'post',
    data
  })
}

// 列表分页1
export function appVersionList1(data) {
  return request({
    url: '/system/api/admin/sysapp/list1',
    method: 'get',
    params: data
  })
}

// 修改APP状态
export function updateAppStatus(data) {
  return request({
    url: '/system/api/admin/sysapp/updateAppStatus',
    method: 'get',
    params: data
  })
}

// 新增AppTenant
export function saveAppTenant(data) {
  return request({
    url: '/system/api/admin/sysapp/saveApp',
    method: 'post',
    data
  })
}

// 列表分页2
export function appVersionList2(data) {
  return request({
    url: '/system/api/admin/sysapp/list2',
    method: 'get',
    params: data
  })
}

// 新增版本信息
export function appVersionSave(data) {
  return request({
    url: '/system/api/admin/sysapp/save',
    method: 'post',
    data
  })
}

// 编辑版本信息
export function appVersionUpdate(data) {
  return request({
    url: '/system/api/admin/sysapp/update',
    method: 'post',
    data
  })
}

// 修改版本状态
export function versionUpdateStatus(data) {
  return request({
    url: '/system/api/admin/sysapp/updateStatus',
    method: 'get',
    params: data
  })
}

// 修改AppTenant
export function updateAppTenant(data) {
  return request({
    url: '/system/api/admin/sysapp/updateApp',
    method: 'post',
    data
  })
}

// 关联车辆列表
export function appUserEbikeList(data) {
  return request({
    url: '/system/api/admin/appUser/ebikeList',
    method: 'get',
    params: data
  })
}

// 反馈分页
export function findFeedbackPage(data) {
  return request({
    url: '/ebike/listek-ebike/web/feedback/findFeedbackPage',
    method: 'post',
    data
  })
}

// 反馈详情
export function findFeedbackDetail(data) {
  return request({
    url: '/ebike/listek-ebike/web/feedback/findFeedbackDetail',
    method: 'post',
    data
  })
}

// 反馈修改状态
export function modifyFeedbackStatus(data) {
  return request({
    url: '/ebike/listek-ebike/web/feedback/modifyFeedbackStatus',
    method: 'post',
    data
  })
}

// 获取厂商-商户，已绑定不需要
export function getAddGeneralTenantList() {
  return request({
    url: '/system/api/admin/sysapp/getAddGeneralTenantList',
    method: 'get'
  })
}

// 新增通用app版本租户
export function addGeneral(data) {
  return request({
    url: '/system/api/admin/sysapp/addGeneral',
    method: 'post',
    data
  })
}

// 通用app版本租户列表
export function generalList(data) {
  return request({
    url: '/system/api/admin/sysapp/generalList',
    method: 'get',
    params: data
  })
}

// 删除通用app版本租户
export function removeGeneral(data) {
  return request({
    url: '/system/api/admin/sysapp/removeGeneral',
    method: 'get',
    params: data
  })
}

// 删除版本
export function sysappDelete(data) {
  return request({
    url: '/system/api/admin/sysapp/delete',
    method: 'get',
    params: data
  })
}

// 售车系统获取版本信息列表
export function saleVersionList(data) {
  return request({
    url: '/system/api/admin/sysapp/saleVersionList',
    method: 'get',
    params: data
  })
}

// 售车系统新增版本
export function saleVersionSave(data) {
  return request({
    url: '/system/api/admin/sysapp/saleVersionSave',
    method: 'post',
    data
  })
}

// 售车系统修改版本
export function saleVersionUpdate(data) {
  return request({
    url: '/system/api/admin/sysapp/saleVersionUpdate',
    method: 'post',
    data
  })
}

// 售车系统删除版本
export function saleVersionDelete(data) {
  return request({
    url: '/system/api/admin/sysapp/saleVersionDelete',
    method: 'get',
    params: data
  })
}

// 售车系统修改版本状态
export function saleVersionUpdateStatus(data) {
  return request({
    url: '/system/api/admin/sysapp/saleVersionUpdateStatus',
    method: 'get',
    params: data
  })
}

// 推送分页列表
export function pushMsgList(data) {
  return request({
    url: '/system/api/admin/pushmsg/list',
    method: 'get',
    params: data
  })
}

// 推送一条数据
export function pushMsgToUser(data) {
  return request({
    url: '/system/api/admin/appUser/pushMsgToUser',
    method: 'post',
    data
  })
}

// 推送给所有人
export function pushMsgToAllUser(data) {
  return request({
    url: '/system/api/admin/appUser/pushMsgToAllUser',
    method: 'post',
    data
  })
}

// 围栏分页
export function findFencePage(data) {
  return request({
    url: '/ebike/listek-ebike/web/fence/findFencePage',
    method: 'post',
    data
  })
}

// 新增围栏
export function addFence(data) {
  return request({
    url: '/ebike/listek-ebike/web/fence/addFence',
    method: 'post',
    data
  })
}

// 编辑围栏
export function modifyFence(data) {
  return request({
    url: '/ebike/listek-ebike/web/fence/modifyFence',
    method: 'post',
    data
  })
}

// 删除围栏
export function removeFence(data) {
  return request({
    url: '/ebike/listek-ebike/web/fence/removeFence',
    method: 'post',
    data
  })
}

// 区域列表
export function findFenceList(data) {
  return request({
    url: '/ebike/listek-ebike/web/fence/findFenceList',
    method: 'post',
    data
  })
}

// 车辆列表
export function findFenceEbikePage(data) {
  return request({
    url: '/ebike/listek-ebike/web/fenceEbkie/findFenceEbikePage',
    method: 'post',
    data
  })
}

// 车辆删除
export function removeFenceEbike(data) {
  return request({
    url: '/ebike/listek-ebike/web/fenceEbkie/removeFenceEbike',
    method: 'post',
    data
  })
}

// 车辆新增
export function addFenceEbike(data) {
  return request({
    url: '/ebike/listek-ebike/web/fenceEbkie/addFenceEbike',
    method: 'post',
    data
  })
}

// 车辆导入
export function importFenceEbike(data) {
  return request({
    url: '/ebike/listek-ebike/web/fenceEbkie/importFenceEbike',
    method: 'post',
    data
  })
}

// 围栏详情
export function findFenceDetail(data) {
  return request({
    url: '/ebike/listek-ebike/web/fence/findFenceDetail',
    method: 'post',
    data
  })
}

// 获取IOT下拉框
export function listNotInEbikeId() {
  return request({
    url: '/ebike/listek-ebike/web/fenceEbkie/listNotInEbikeId',
    method: 'get'
  })
}

// 出入对账
export function findFenceLogPage(data) {
  return request({
    url: '/ebike/listek-ebike/web/fencelog/findFenceLogPage',
    method: 'post',
    data
  })
}

// 出入对账
export function exportFenceLog(data) {
  return request({
    url: '/ebike/listek-ebike/web/fencelog/exportFenceLog',
    method: 'post',
    data
  })
}

// 轨迹
export function locus(params) {
  return request({
    url: '/ebike/listek-ebike/web/fencelog/locus',
    method: 'get',
    params
  })
}

// 获取APP配置
export function getAppConfigure(params) {
  return request({
    url: '/system/api/admin/sysapp/getAppConfigure',
    method: 'get',
    params
  })
}

// 提交APP配置
export function updateAppConfigure(data) {
  return request({
    url: '/system/api/admin/sysapp/updateAppConfigure',
    method: 'post',
    data
  })
}

// 查询维修记录
export function queryMaintainRecordPage(data) {
  return request({
    url: '/ebike/listek-ebike/web/ebike/saleMaintain/queryMaintainRecordPage',
    method: 'post',
    data
  })
}

// 导出维修记录
export function exportEbikeMaintainRecord(data) {
  return request({
    url: '/system/api/admin/export/ebikeMaintainRecord',
    method: 'post',
    data
  })
}

// 查询销售记录
export function querySaleRecordPage(data) {
  return request({
    url: '/ebike/listek-ebike/web/ebike/saleMaintain/querySaleRecordPage',
    method: 'post',
    data
  })
}

// 导出销售记录
export function exportEbikeSaleRecord(data) {
  return request({
    url: '/system/api/admin/export/ebikeSaleRecord',
    method: 'post',
    data
  })
}

// 查询维修类型
export function queryEbikeMaintainTypeList(data) {
  return request({
    url: '/ebike/listek-ebike/web/ebike/saleMaintain/queryEbikeMaintainTypeList',
    method: 'get',
    params: data
  })
}

// 获取app下载信息
export function getAppDownloadInfo(data) {
  return request({
    url: '/system/api/admin/sysapp/getAppDownloadInfo',
    method: 'get',
    params: data
  })
}
